"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_SIZE_MULTIPLIER = void 0;
const IMAGE_SIZE_MULTIPLIER = exports.IMAGE_SIZE_MULTIPLIER = 1;
